import { Button } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CreateInvoiceButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      variant="secondary"
      colorScheme="v2-aurora"
      onClick={() => navigate('/invoices/create')}
    >
      Create Invoice
    </Button>
  );
};
